<template>
  <div class="min-h-screen flex flex-col lg:flex-row bg-white overflow-hidden">
    <!-- Left Section: Branding & Visuals (Desktop Only) -->
    <div class="hidden lg:flex lg:w-1/2 relative bg-gray-900 text-white overflow-hidden">
      <!-- Background Image with Overlay -->
      <div 
        class="absolute inset-0 z-0 bg-cover bg-center transition-transform duration-[20s] ease-in-out hover:scale-110"
        style="background-image: url('https://images.unsplash.com/photo-1500382017468-9049fed747ef?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80');"
      ></div>
      <div class="absolute inset-0 z-10 bg-gradient-to-br from-green-900/90 to-black/60 backdrop-blur-[2px]"></div>
      
      <!-- Decorative Elements -->
      <div class="absolute top-0 left-0 w-full h-full z-20 overflow-hidden pointer-events-none">
         <div class="absolute -top-24 -left-24 w-96 h-96 bg-green-500/20 rounded-full blur-3xl filter"></div>
         <div class="absolute top-1/2 right-0 w-64 h-64 bg-teal-500/20 rounded-full blur-3xl filter"></div>
      </div>

      <!-- Content -->
      <div class="relative z-30 flex flex-col justify-between w-full h-full p-16">
        <!-- Brand -->
        <div class="flex items-center space-x-3">
          <div class="bg-white/10 p-2 rounded-xl backdrop-blur-md border border-white/10 shadow-lg">
             <img src="@/assets/farm-dashboard-preview.png" alt="Rochex Logo" class="w-8 h-8" />
          </div>
          <span class="text-2xl font-bold tracking-wide">Rochex <span class="text-green-400">Investments</span></span>
        </div>

        <!-- Main Text -->
        <div class="space-y-6 max-w-lg">
          <h1 class="text-5xl font-bold leading-tight">
            Cultivating <br/>
            <span class="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-teal-300">Success</span>
             Together
          </h1>
          <p class="text-lg text-gray-300 leading-relaxed font-light">
            Manage your farm operations with precision. Track expenses, monitor yields, and optimize production with our advanced agricultural platform.
          </p>
          
          <!-- Testimonial/Stats -->
          <div class="flex items-center space-x-4 pt-4">
             <div class="flex -space-x-4">
                <img class="w-10 h-10 rounded-full border-2 border-green-900" src="https://i.pravatar.cc/100?img=33" alt="User" />
                <img class="w-10 h-10 rounded-full border-2 border-green-900" src="https://i.pravatar.cc/100?img=47" alt="User" />
                <img class="w-10 h-10 rounded-full border-2 border-green-900" src="https://i.pravatar.cc/100?img=12" alt="User" />
                <div class="w-10 h-10 rounded-full border-2 border-green-900 bg-green-600 flex items-center justify-center text-xs font-bold text-white">
                  +2k
                </div>
             </div>
             <div class="flex flex-col">
                <span class="font-bold text-white">Trust by Farmers</span>
                <span class="text-xs text-green-400/80">Active users worldwide</span>
             </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="flex justify-between items-center text-xs text-gray-400 font-medium">
          <div class="flex space-x-6">
            <a href="#" class="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" class="hover:text-white transition-colors">Terms of Use</a>
          </div>
          <p>© 2025 Rochex Investments.</p>
        </div>
      </div>
    </div>

    <!-- Right Section: Form Content -->
    <div class="flex-1 flex flex-col justify-center items-center p-8 sm:p-12 relative bg-gray-50/50">
      <!-- Mobile Header -->
      <div class="lg:hidden w-full max-w-md mb-8 flex items-center space-x-3">
         <div class="bg-green-600/10 p-2 rounded-xl">
             <img src="@/assets/farm-dashboard-preview.png" alt="Rochex Logo" class="w-8 h-8" />
          </div>
          <span class="text-2xl font-bold text-gray-900">Rochex <span class="text-green-600">Investments</span></span>
      </div>

      <!-- Auth Container -->
      <div class="w-full max-w-md bg-white rounded-3xl shadow-[0_20px_50px_rgba(0,0,0,0.05)] border border-gray-100 overflow-hidden relative">
         <!-- Geometric Decoration -->
         <div class="absolute top-0 right-0 -mr-16 -mt-16 w-32 h-32 bg-gradient-to-br from-green-500 to-teal-500 rounded-full blur-2xl opacity-10"></div>
         <div class="absolute bottom-0 left-0 -ml-16 -mb-16 w-32 h-32 bg-gradient-to-tr from-blue-500 to-purple-500 rounded-full blur-2xl opacity-10"></div>

        <div class="p-2 sm:p-4 relative z-10">
           <!-- Slot for Header (Login/Register Title) -->
           <div v-if="$slots.header" class="mb-8">
             <slot name="header"></slot>
           </div>
           
           <!-- Main Slot -->
           <slot></slot>
        </div>
        
        <!-- Bottom Link Slot (Optional) -->
        <div v-if="$slots.footer" class="bg-gray-50 px-8 py-4 border-t border-gray-100 text-center">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// No script needed for this layout
</script>

<style scoped>
/* Smooth fade transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>